import { FC } from "react";
import { CustomCellRendererProps } from "ag-grid-react";
import Typography from "@mui/material/Typography";
import { ProcessedHistoryData } from "@/store/budgets/selectors/details-drawer/budgetDetailsHistoryProcessedDataSelector";
import { BudgetNoCollectedDataChip } from "@/components/pages/budgets-and-alerts/components/grids/budgets/components/cells/BudgetNoCollectedDataChip";
import { money } from "@/utils/numeral/money";

export const BudgetDetailsHistoryUsedCell: FC<
  CustomCellRendererProps<ProcessedHistoryData>
> = ({ data }) => {
  if (typeof data?.used === "string") {
    return <BudgetNoCollectedDataChip />;
  }

  return <Typography variant="body2">{money(data?.used)}</Typography>;
};
